package com.patronat.top.features.dashboard.data.network

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.DashboardStatsResponse
import io.ktor.client.HttpClient
import io.ktor.client.request.get

class DashboardRemoteDataStore(
    private val httpClient: HttpClient
) {
    suspend fun getDashboardStats(): NetworkResult<DashboardStatsResponse> {
        return safeApiCall {
            httpClient.get("dashboard/stats")
        }
    }
}
